import { render, staticRenderFns } from "./Rectangle.vue?vue&type=template&id=deaeb41a"
import script from "./Rectangle.js?vue&type=script&lang=js&external"
export * from "./Rectangle.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports